/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Taiyoro_BlurbInputs */

const ja_home_brands_taiyoro_blurb = /** @type {(inputs: Home_Brands_Taiyoro_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新のゲームイベント情報やeスポーツ大会のVOD、大会スケジュールを提供するポータルサイトです。`)
};

const en_home_brands_taiyoro_blurb = /** @type {(inputs: Home_Brands_Taiyoro_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online platform to discover and interact around esports events in Japan. Promote your activities or run campaigns to help your sponsor brands make a more meaningful activation for the audience.`)
};

/**
* | output |
* | --- |
* | "Online platform to discover and interact around esports events in Japan. Promote your activities or run campaigns to help your sponsor brands make a more mea..." |
*
* @param {Home_Brands_Taiyoro_BlurbInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_taiyoro_blurb = /** @type {((inputs?: Home_Brands_Taiyoro_BlurbInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Taiyoro_BlurbInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_taiyoro_blurb(inputs)
	return en_home_brands_taiyoro_blurb(inputs)
});